import { useState } from "react";
import { useSwipeable } from "react-swipeable";
import { Box, Typography, IconButton } from "@mui/material";

import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";

const GAP = 20;

export default function ResourceCarousel({ items = [], showBorder = true }) {
  const [index, setIndex] = useState(0);
  const [deltaX, setDeltaX] = useState(0);

  const max = items.length;

  const next = () => setIndex((i) => (i + 1) % max);
  const prev = () => setIndex((i) => (i - 1 + max) % max);

  const handlers = useSwipeable({
    onSwiping: (e) => setDeltaX(e.deltaX),
    onSwipedLeft: () => {
      next();
      setDeltaX(0);
    },
    onSwipedRight: () => {
      prev();
      setDeltaX(0);
    },
    trackMouse: true,
    preventScrollOnSwipe: true,
  });

  if (!items.length) return null;

  return (
    <Box
      {...handlers}
      sx={{
        border: showBorder ? "1.5px solid #ffd700" : "none",
        borderRadius: "12px",
        width: { xs: "100%", sm: "400px" },
        overflow: "hidden",
        userSelect: "none",
        py: 1,
      }}
    >
      {/* TRACK */}
      <Box
        sx={{
          display: "flex",
          width: "100%",
                    gap: `${GAP}px`,
          transform:  `translateX(calc(-${index} * (100% + ${GAP}px) + ${deltaX}px))`,
          transition: deltaX ? "none" : "transform 0.35s ease",
        }}
      >
        {items.map((item, i) => {
          const Icon = item.Icon;

          return (
            <Box
              key={i}
              sx={{
                minWidth: "100%",
                px: 0, // spacing between slides
                boxSizing: "border-box",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box
                key={i}
                sx={{
                  minWidth: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: !showBorder ? "1.5px solid #ffd700" : "none",
                  borderRadius: !showBorder ? "12px" : "none",
                  gap: 2,
                  py: 2,
                  px: 2,
                }}
              >
                <Typography
                  sx={{
                    color: "#5f2e20",
                    fontWeight: 800,
                    fontSize: "0.875rem",
                  }}
                >
                  {item.title}
                </Typography>

                {item.isImage ? (
                  <img
                    src={item.Icon}
                    alt=""
                    style={{
                      width: 28,
                      height: 28,
                      objectFit: "contain",
                    }}
                  />
                ) : item.isEmoji ? (
                  <span style={{ fontSize: 22 }}>{item.Icon}</span>
                ) : item.isMui ? (
                  <Icon sx={{ color: "#ffd700", fontSize: 28 }} />
                ) : (
                  <Icon style={{ width: 28, height: 28 }} />
                )}
              </Box>
            </Box>
          );
        })}
      </Box>

      {/* CONTROLS */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mt: 1,
        }}
      >
        <IconButton onClick={prev} size="small">
          <KeyboardArrowLeft sx={{ color: "#ffd700" }} />
        </IconButton>

        <Box sx={{ display: "flex", gap: 1 }}>
          {items.map((_, i) => (
            <Box
              key={i}
              onClick={() => setIndex(i)}
              sx={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                cursor: "pointer",
                backgroundColor:
                  i === index ? "#ffd700" : "rgba(255,215,0,0.3)",
                transition: "0.2s",
              }}
            />
          ))}
        </Box>

        <IconButton onClick={next} size="small">
          <KeyboardArrowRight sx={{ color: "#ffd700" }} />
        </IconButton>
      </Box>
    </Box>
  );
}
